<script setup lang="ts">
import OverlayPanel from 'primevue/overlaypanel';
import { ref } from 'vue';

import eventBus from 'lib/event-bus';

import {
  OverlayPanelEmits,
  OverlayPanelProps,
  OverlayPanelSlots,
} from './OverlayPanel.vue.d';

const props = withDefaults(defineProps<OverlayPanelProps>(), {
  dismissable: true,
  dismissableOverlay: true,
  showCloseIcon: false,
  baseZIndex: 0,
  autoZIndex: true,
  unstyled: false,
  closeOnEscape: true,
});

const emit = defineEmits<OverlayPanelEmits>();

const slots = defineSlots<OverlayPanelSlots>();
const overlayId = +new Date();
const op = ref<OverlayPanel>();
const onHideOverlay = (): void => {
  eventBus.off('overlay:show', hideOverlay);
  emit('hide');
};

const hideOverlay = (event: { overlayId: number }): void => {
  if (op.value && event.overlayId !== overlayId && props.dismissableOverlay)
    op.value.hide();
};

const onShowOverlay = async (): Promise<void> => {
  eventBus.emit('overlay:show', { overlayId });
  eventBus.on('overlay:show', hideOverlay);
  emit('show');
};

const toggle = (event: Event, target?: any): void => {
  op.value.toggle(event, target);
};

const alignOverlay = (): void => {
  op.value.alignOverlay();
};

const show = (event: Event, target?: any): void => {
  op.value.show(event, target);
};

const hide = (): void => {
  op.value.hide();
};

defineExpose({ toggle, hide, show, alignOverlay });
</script>

<template>
  <OverlayPanel
    v-bind="$props"
    :id="overlayId"
    ref="op"
    @hide="onHideOverlay"
    @show="onShowOverlay"
  >
    <slot name="default" />

    <template
      #container="{ closeCallback, keydownCallback }"
      v-if="slots['container']"
    >
      <slot
        :close-callback="closeCallback"
        :keydown-callback="keydownCallback"
        name="container"
      />
    </template>
  </OverlayPanel>
</template>
